import template from './SIcon.html';

export default {
	template,
	props: ['icon', 'fallback']
};